import { Menu, MenuItem } from '@mui/material';
import { INVOICE_BILLING_STATUSES, type InvoiceBillingStatus } from '@weft/types';
import { isNotNullOrUndefined, values } from '@weft/utils';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import React from 'react';
import { InvoiceBillingStatusLabel } from '../InvoiceBillingStatusLabel';

type BillingStatusMenuProps = {
  children?: React.ReactElement;
  onUpdateInvoicesBillingStatus: (status: InvoiceBillingStatus) => void
  onClose?: () => void;
};

export const BillingStatusMenu: React.FC<BillingStatusMenuProps> = ({
  onUpdateInvoicesBillingStatus,
  onClose,
  children,
}) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  const handleItemClick = (status: InvoiceBillingStatus) => {
    onUpdateInvoicesBillingStatus(status);
    closeMenu();
  };

  const closeMenu = () => {
    handleMenuClose();
    onClose?.();
  };

  return (
    <>
      {isNotNullOrUndefined(children) && React.cloneElement(children, {
        onClick: handleMenuOpen,
      })}
      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={closeMenu}
        MenuListProps={{
          className: 'py-2',
        }}
        slotProps={{
          paper: {
            className: 'px-0 rounded-lg ml-[-24px] mt-[-14px]',
          },
        }}
      >
        <div className="space-y-1">
          {values(INVOICE_BILLING_STATUSES).map((statusItem, index) => {
            return (
              <MenuItem
                key={index}
                onClick={() => handleItemClick(statusItem)}
                className='px-4'
              >
                <InvoiceBillingStatusLabel billingStatus={statusItem}/>
              </MenuItem>
            );
          })}
        </div>
      </Menu>
    </>
  );
};